import React from 'react';
import { string, arrayOf, shape, bool } from 'prop-types';
import classNames from 'classnames';
import StyledLabel from '../styled-label';
import MediaAction from '../media/media-action';
import ActionsBuybox from '../buybox/actions/actions-buybox';
import Media from '../media';

const namespace = 'ui-pdp-service-faq';

const ServiceFaq = ({ className, header, contentRows, contentRowLink, containerActions, featureName, itemId }) => (
  <div className={classNames(namespace, className)}>
    <StyledLabel className={`${namespace}__title`} {...header} />
    {contentRows.map(row => (
      <Media key={row.title.text} {...row} />
    ))}
    {contentRowLink && (
      <MediaAction
        target={contentRowLink.target}
        track={contentRowLink.track}
        htmlTarget="_blank"
        className={`${namespace}__action`}
        label={{ text: contentRowLink.label ? contentRowLink.label.text : null }}
      />
    )}
    {containerActions && (
      <div className={`${namespace}__container-actions`}>
        {containerActions.map(actionRow => (
          <ActionsBuybox
            key={actionRow.actions[0].label.text}
            itemId={itemId}
            featureName={featureName}
            {...actionRow}
          />
        ))}
      </div>
    )}
  </div>
);

ServiceFaq.propTypes = {
  className: string,
  featureName: string.isRequired,
  itemId: string.isRequired,
  header: shape({
    text: string,
    color: string,
    font_size: string,
    font_family: string,
  }).isRequired,
  contentRows: arrayOf(
    shape({
      icon: shape({
        id: string.isRequired,
        color: string,
      }),
      title: shape({
        text: string,
        color: string,
        font_size: string,
        font_family: string,
      }),
      subtitles: arrayOf(
        shape({
          text: string,
          color: string,
          font_size: string,
          font_family: string,
        }),
      ),
    }),
  ).isRequired,
  contentRowLink: shape({
    type: string,
    target: string.isRequired,
    label: shape({
      text: string.isRequired,
    }),
    track: shape(),
    disabled: bool,
  }).isRequired,
  containerActions: arrayOf(
    shape({
      actions: arrayOf(shape()),
    }),
  ),
};

ServiceFaq.defaultProps = {
  className: null,
  containerActions: null,
};

export default React.memo(ServiceFaq);
